import { ViewDensity } from "@common/types/views/views";
import { CounterpartyContactsColumn } from "@common/types/views/counterpartyContactsView";
import { CounterpartyContact } from "@common/schemas/counterpartyContact.schema";
import { ViewConfig } from "@lib/views";
import { CounterpartyContactActionsCell } from "./cells/CounterpartyBookActionsCell";
import { CounterpartyContactPrimaryCell } from "./cells/CounterpartyBookPrimaryCell";
import { CounterpartyContactTextCell } from "./cells/CounterpartyBookTextCell";
import { CounterpartyContactNameCell } from "./cells/CounterpartyContactNameCell";

export const createCounterpartyContactsViewConfig = (): ViewConfig<
    CounterpartyContact,
    CounterpartyContactsColumn,
    never
> => ({
    columns: {
        [CounterpartyContactsColumn.NAME]: {
            accessorKey: "firstName",
            name: "Name",
            header: "Name",
            immutable: true,
            cell: CounterpartyContactNameCell,
            minSize: 140,
        },
        [CounterpartyContactsColumn.EMAIL]: {
            accessorKey: "email",
            name: "Email",
            header: "Email",
            immutable: true,
            cell: CounterpartyContactTextCell,
            minSize: 140,
        },
        [CounterpartyContactsColumn.PHONE]: {
            accessorKey: "phoneNumber",
            name: "Phone",
            header: "Phone",
            immutable: true,
            cell: CounterpartyContactTextCell,
            minSize: 120,
        },
        [CounterpartyContactsColumn.PRIMARY]: {
            accessorKey: "isPrimary",
            name: "Primary",
            header: "Primary",
            immutable: true,
            cell: CounterpartyContactPrimaryCell,
            minSize: 80,
            maxSize: 100,
        },
        [CounterpartyContactsColumn.ACTIONS]: {
            accessorKey: "id",
            name: "Actions",
            header: "",
            align: "right",
            immutable: true,
            hiddenFromSettings: true,
            cell: CounterpartyContactActionsCell,
            minSize: 48,
            maxSize: 56,
        },
    },
    density: ViewDensity.SM,
});
